import React from "react";
import Helmet from "react-helmet";

interface StructuredDataProps {
  type: "Article" | "WebPage" | "Blog";
  title: string;
  description?: string;
  url: string;
  datePublished?: string;
  dateModified?: string;
  author?: {
    name: string;
    url?: string;
  };
  image?: string;
}

const StructuredData: React.FC<StructuredDataProps> = ({
  type,
  title,
  description,
  url,
  datePublished,
  dateModified,
  author,
  image,
}) => {
  const schema: Record<string, unknown> = {
    "@context": "https://schema.org",
    "@type": type,
    headline: title,
    url,
  };

  if (description) {
    schema.description = description;
  }

  if (datePublished) {
    schema.datePublished = datePublished;
  }

  if (dateModified) {
    schema.dateModified = dateModified;
  } else if (datePublished) {
    schema.dateModified = datePublished;
  }

  if (author) {
    schema.author = {
      "@type": "Person",
      name: author.name,
      ...(author.url && { url: author.url }),
    };
  }

  if (image) {
    schema.image = image;
  }

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};

export default StructuredData;

